/**
 * Created by hao.cheng on 2017/5/7.
 */
import React from 'react';
import CkPage from "../../components/CkPage";
import styled from "styled-components";
import {Button} from "antd";
import Iconfont from "../../components/Iconfont/Iconfont";



class AttendeeLuckydrawGuidePage extends React.Component {
    state = {
        animated: ''
    };

    render() {
        const ckPageContent = <div style={{backgroundColor:'#fff',padding:16}}>
            <div>
                <div style={{display:'flex',alignItems:'center'}}>
                    <Iconfont style={{fontSize:30,color:'#EC6A59'}}  libname="ckicon" type="shuzisucai3"/>
                    <span style={{fontSize:14,margin:'0 10px'}}>该服务需要高级会员权限，请去</span>
                    <Button  type="primary" ghost  onClick={()=>{
                    this.props.router.push("/admin/mall/products");
                }}>商城购买</Button>
                </div>
                <img style={{marginLeft:49}} src="https://img.qdj8.cn/wall-bg1.jpg" alt=""/>
            </div>
            <div>
                <div style={{display:'flex',alignItems:'center'}}>
                    <Iconfont style={{fontSize:30,color:'#9CBC23'}}  libname="ckicon" type="shuzisucai4"/>
                    <span style={{fontSize:14,margin:'0 10px'}}>幸运大转盘—创建简单，2分钟既可发布，微信活动首选，引爆活动，自定义抽奖设置。</span>
                    <Button  type="primary" ghost  onClick={()=>{
                        window.open('https://www.bilibili.com/video/av24187436/')
                    }}>视频演示</Button>
                </div>
                <img style={{marginLeft:49}} src="https://img.qdj8.cn/attdraw-bg.jpg" alt=""/>
            </div>
        </div>

        return (
            <CkPage title={null} content={ckPageContent}/>
        )
    }
}

export default AttendeeLuckydrawGuidePage;


// WEBPACK FOOTER //
// ./src/containers/luckydraw/AttendeeLuckydrawGuidePage.jsx